import { MISC_OFFICIAL_AUDIENCES, MISC_OFFICIAL_SERVICES } from "./index";
import { buildLegalClusterQA, toAxis, type WaveQA } from "../_qa/legal-clusters";

export type MiscOfficialQA = WaveQA;

export const MISC_OFFICIAL_REVIEWED_TH = "สิงหาคม 2569";
export const MISC_OFFICIAL_REVIEWED_ISO = "2026-08-07";

export const MISC_OFFICIAL_QA: MiscOfficialQA[] = buildLegalClusterQA({
  prefix: "misc-official",
  clusterTh: "งานเอกสารราชการเฉพาะเรื่อง",
  authorityTh: "หน่วยงานราชการเจ้าของเรื่อง",
  reviewedTh: MISC_OFFICIAL_REVIEWED_TH,
  volatileNote:
    "แบบฟอร์ม ช่องทางยื่น และระยะเวลาพิจารณาของแต่ละหน่วยงานเปลี่ยนได้ ควรยืนยันกับหน่วยงานเจ้าของเรื่องก่อนยื่น",
  topics: toAxis(MISC_OFFICIAL_SERVICES),
  extraTopics: toAxis(MISC_OFFICIAL_AUDIENCES, "aud"),
});

export const MISC_OFFICIAL_QA_BY_SLUG: Record<string, MiscOfficialQA> = Object.fromEntries(
  MISC_OFFICIAL_QA.map((qa) => [qa.slug, qa]),
);

export const MISC_OFFICIAL_QA_COUNT = MISC_OFFICIAL_QA.length;
